import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseMessageService {
  public PLEASE_SCROLL: string = 'Please scroll down to read the Terms and Conditions.';
}
